import React, { useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";
import "../../DealApproval.scss";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
import { isValidMeaningfulData } from "../helpers";

const BulletListForm = ({
    itemIndex,
    blockItem,
    selectedBulletColor,
    bulletColorOptions = [],
    prefixTypeOptions = [],
    onUpdateBlockItem,
    onDeleteBlockItem,
    onColorChange,
    isFirstItem,
}) => {
    const [validationError, setValidationError] = useState("");
    const defaultPrefixType = prefixTypeOptions[0]?.optionValue || "";
    const prefixOptions = prefixTypeOptions.map((opt) => ({
        value: opt.optionValue,
        label: opt.optionValue === "number" ? `${itemIndex + 1}.` : opt.optionLabel,
    }));

    const handleItemChange = (e) => {
        const value = e.target.value;
        onUpdateBlockItem(itemIndex, "item", value);
        
        const trimmedValue = value.trim();
        if (trimmedValue && !isValidMeaningfulData(trimmedValue)) {
            setValidationError("Please enter a valid and meaningful data");
        } else {
            setValidationError("");
        }
    };

    return (
        <>
            {/* {isFirstItem && (
                <div className="form-group bullet-color-group">
                    <label>Bullet color (Default color is black)</label>
                    <div className="bullet-color-select-wrap">
                        <span className="bullet-color-swatch" style={{ background: bulletColorHex }} />
                        <CustomSelect
                            className="bullet-color-select"
                            options={bulletColorOptions.map((opt) => ({ value: opt.optionValue, label: opt.optionLabel }))}
                            value={selectedBulletColor}
                            onChange={(value) => onColorChange(value)}
                        />
                    </div>
                </div>
            )} */}

            {itemIndex === 0 && (
                <label className="bullet-list-heading">
                    Bullet List <span className="required-mark">*</span>
                </label>
            )}
            <div className="bullet-list-row">
                <div className="bullet-prefix-field">
                    <CustomSelect
                        options={prefixOptions}
                        value={blockItem.prefixType || defaultPrefixType}
                        onChange={(value) => onUpdateBlockItem(itemIndex, "prefixType", value)}
                    />
                </div>

                <input
                    className={`bullet-item-input ${validationError ? "input-error" : ""}`}
                    type="text"
                    placeholder="Enter a key point..."
                    value={blockItem.item || ""}
                    maxLength={500}
                    onChange={handleItemChange}
                />

                <button
                    type="button"
                    className="bullet-delete-btn"
                    onClick={() => onDeleteBlockItem(itemIndex)}
                >
                    <DeleteOutlined />
                </button>
            </div>
            <div className="error-counter-row">
                {validationError ? <p className="form-error-text">{validationError}</p> : <span className="error-placeholder" />}
                <span className="char-counter-text">{(blockItem.item || "").length}/500</span>
            </div>
            {(blockItem.item || "").length >= 500 && <p className="char-limit-note">Max 500 characters reached</p>}
        </>
    );
};

export default BulletListForm;
